export default {
  // 邊類型描述
  expandEdge: "這是擴展邊",
  addressOwnership: "這是地址歸屬",
  hashNote: "這是哈希備註",
  watchAddress: "這是觀察地址",
  sameIpAccount: "同ip賬號",
  sameDeviceAccount: "同設備賬號",

  // 交易信息標籤
  sender: "發送方",
  receiver: "接收方",
  transactionHash: "交易哈希",
  transactionTime: "交易時間",
  transactionQuantity: "交易數量",
  averageQuantity: "平均數量",

  // 註釋中的標籤（保留用於將來可能的顯示）
  currencyName: "幣種名稱",
  totalQuantity: "總數量",
  totalCount: "總筆數",
};
